import { useEffect, useState } from 'react';
import { EventEmitter } from 'events';
import useVideoContext from '../useVideoContext/useVideoContext';

/**
 * Returns true once the room has been connected at least once.
 * This allows distinguishing between "never joined" and "call ended" states.
 */
export default function useHasBeenConnected() {
  const { room } = useVideoContext();
  const [hasBeenConnected, setHasBeenConnected] = useState(false);

  useEffect(() => {
    const handleConnected = () => setHasBeenConnected(true);

    // Check if already connected
    if (room.state === 'connected') {
      setHasBeenConnected(true);
    }

    // twilio-video's Room type has no 'connected' event; the room here is an EventEmitter until the
    // real one replaces it, so listen on it as one.
    const emitter = room as unknown as EventEmitter;
    emitter.on('connected', handleConnected);
    return () => {
      emitter.off('connected', handleConnected);
    };
  }, [room]);

  return hasBeenConnected;
}
